// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "app/dataset/v1/dataset.proto" (package "viam.app.dataset.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../google/protobuf/timestamp";
/**
 * Dataset stores the metadata of a dataset.
 *
 * @generated from protobuf message viam.app.dataset.v1.Dataset
 */
export interface Dataset {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string organization_id = 3;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp time_created = 4;
     */
    timeCreated?: Timestamp;
    /**
     * type is the membership kind of this dataset. Immutable after creation; defaults to
     * DATASET_TYPE_BINARY_DATA when unset (including for pre-existing datasets).
     *
     * @generated from protobuf field: viam.app.dataset.v1.DatasetType type = 5;
     */
    type: DatasetType;
}
/**
 * CreateDatasetRequest defines the name and organization ID of a dataset.
 *
 * @generated from protobuf message viam.app.dataset.v1.CreateDatasetRequest
 */
export interface CreateDatasetRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string organization_id = 2;
     */
    organizationId: string;
    /**
     * type is the membership kind for the new dataset. Defaults to DATASET_TYPE_BINARY_DATA when unset.
     *
     * @generated from protobuf field: optional viam.app.dataset.v1.DatasetType type = 3;
     */
    type?: DatasetType;
}
/**
 * CreateDatasetResponse returns the dataset ID of the created dataset.
 *
 * @generated from protobuf message viam.app.dataset.v1.CreateDatasetResponse
 */
export interface CreateDatasetResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * DeleteDatasetRequest deletes the dataset specified by the dataset ID.
 *
 * @generated from protobuf message viam.app.dataset.v1.DeleteDatasetRequest
 */
export interface DeleteDatasetRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.dataset.v1.DeleteDatasetResponse
 */
export interface DeleteDatasetResponse {
}
/**
 * RenameDatasetRequest applies the new name to the dataset specified by the dataset ID.
 *
 * @generated from protobuf message viam.app.dataset.v1.RenameDatasetRequest
 */
export interface RenameDatasetRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
}
/**
 * @generated from protobuf message viam.app.dataset.v1.RenameDatasetResponse
 */
export interface RenameDatasetResponse {
}
/**
 * ListDatasetsByOrganizationIDRequest requests all of the datasets for an organization,
 * optionally filtering on DatasetType
 *
 * @generated from protobuf message viam.app.dataset.v1.ListDatasetsByOrganizationIDRequest
 */
export interface ListDatasetsByOrganizationIDRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * Optional DataseType to filter on.
     * If unset, will return all types.
     *
     * @generated from protobuf field: optional viam.app.dataset.v1.DatasetType type = 2;
     */
    type?: DatasetType;
}
/**
 * ListDatasetsByOrganizationIDResponse returns all the dataset metadata for the organization.
 *
 * @generated from protobuf message viam.app.dataset.v1.ListDatasetsByOrganizationIDResponse
 */
export interface ListDatasetsByOrganizationIDResponse {
    /**
     * @generated from protobuf field: repeated viam.app.dataset.v1.Dataset datasets = 1;
     */
    datasets: Dataset[];
}
/**
 * ListDatasetsByIDsRequest requests all of the datasets by their dataset IDs.
 *
 * @generated from protobuf message viam.app.dataset.v1.ListDatasetsByIDsRequest
 */
export interface ListDatasetsByIDsRequest {
    /**
     * @generated from protobuf field: repeated string ids = 1;
     */
    ids: string[];
}
/**
 * ListDatasetsByIDsResponse returns all the dataset metadata for the associated dataset IDs.
 *
 * @generated from protobuf message viam.app.dataset.v1.ListDatasetsByIDsResponse
 */
export interface ListDatasetsByIDsResponse {
    /**
     * @generated from protobuf field: repeated viam.app.dataset.v1.Dataset datasets = 1;
     */
    datasets: Dataset[];
}
/**
 * MergeDatasetsRequest merges multiple datasets specified by their dataset IDs into a new dataset.
 *
 * @generated from protobuf message viam.app.dataset.v1.MergeDatasetsRequest
 */
export interface MergeDatasetsRequest {
    /**
     * @generated from protobuf field: repeated string dataset_ids = 1;
     */
    datasetIds: string[];
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string organization_id = 3;
     */
    organizationId: string;
}
/**
 * MergeDatasetsResponse returns the dataset ID of the newly created merged dataset.
 *
 * @generated from protobuf message viam.app.dataset.v1.MergeDatasetsResponse
 */
export interface MergeDatasetsResponse {
    /**
     * @generated from protobuf field: string dataset_id = 1;
     */
    datasetId: string;
}
/**
 * StartSequenceDatasetExportRequest specifies the sequence dataset to export.
 *
 * @generated from protobuf message viam.app.dataset.v1.StartSequenceDatasetExportRequest
 */
export interface StartSequenceDatasetExportRequest {
    /**
     * @generated from protobuf field: string dataset_id = 1;
     */
    datasetId: string;
}
/**
 * StartSequenceDatasetExportResponse returns the job_id to poll with
 *
 * @generated from protobuf message viam.app.dataset.v1.StartSequenceDatasetExportResponse
 */
export interface StartSequenceDatasetExportResponse {
    /**
     * @generated from protobuf field: string job_id = 1;
     */
    jobId: string;
}
/**
 * GetSequenceDatasetExportRequest looks up an export job by its job_id.
 *
 * @generated from protobuf message viam.app.dataset.v1.GetSequenceDatasetExportRequest
 */
export interface GetSequenceDatasetExportRequest {
    /**
     * @generated from protobuf field: string job_id = 1;
     */
    jobId: string;
}
/**
 * GetSequenceDatasetExportResponse reports the current status of an export
 * job. download_url and expires_at are set only when status is COMPLETED;
 * error_message is set only when status is FAILED.
 *
 * @generated from protobuf message viam.app.dataset.v1.GetSequenceDatasetExportResponse
 */
export interface GetSequenceDatasetExportResponse {
    /**
     * @generated from protobuf field: string job_id = 1;
     */
    jobId: string;
    /**
     * @generated from protobuf field: viam.app.dataset.v1.SequenceDatasetExportStatus status = 2;
     */
    status: SequenceDatasetExportStatus;
    /**
     * Short-lived (e.g. 1h) signed URL for direct download from backing
     * storage. Empty unless status is COMPLETED.
     *
     * @generated from protobuf field: string download_url = 3;
     */
    downloadUrl: string;
    /**
     * When download_url stops working. Empty unless status is COMPLETED.
     *
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 4;
     */
    expiresAt?: Timestamp;
    /**
     * Human-readable cause; empty unless status is FAILED.
     *
     * @generated from protobuf field: string error_message = 5;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 7;
     */
    completedAt?: Timestamp;
}
/**
 * DatasetType describes the kind of membership a dataset stores.
 * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
 *
 * @generated from protobuf enum viam.app.dataset.v1.DatasetType
 */
export enum DatasetType {
    /**
     * DATASET_TYPE_BINARY_DATA is a dataset whose members are individual binary data objects (frames).
     * This is the default for datasets created without an explicit type, including all pre-existing
     * datasets.
     *
     * @generated from protobuf enum value: DATASET_TYPE_BINARY_DATA = 0;
     */
    BINARY_DATA = 0,
    /**
     * DATASET_TYPE_SEQUENCE_DATA is a dataset whose members are sequences. Binary-data writes
     * (AddBinaryDataToDatasetByIDs, AddBinaryDataToDatasetByFilter) are rejected against datasets
     * of this type; sequences are added/removed via AddSequencesToDataset / RemoveSequencesFromDataset.
     *
     * @generated from protobuf enum value: DATASET_TYPE_SEQUENCE_DATA = 1;
     */
    SEQUENCE_DATA = 1
}
/**
 * SequenceDatasetExportStatus is the lifecycle state of an export job.
 *
 * @generated from protobuf enum viam.app.dataset.v1.SequenceDatasetExportStatus
 */
export enum SequenceDatasetExportStatus {
    /**
     * @generated from protobuf enum value: SEQUENCE_DATASET_EXPORT_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * PENDING — accepted, not yet picked up.
     *
     * @generated from protobuf enum value: SEQUENCE_DATASET_EXPORT_STATUS_RUNNING = 1;
     */
    RUNNING = 1,
    /**
     * COMPLETED — Parquet file is uploaded; download_url is set.
     *
     * @generated from protobuf enum value: SEQUENCE_DATASET_EXPORT_STATUS_COMPLETED = 2;
     */
    COMPLETED = 2,
    /**
     * FAILED — terminal; error_message describes the cause.
     *
     * @generated from protobuf enum value: SEQUENCE_DATASET_EXPORT_STATUS_FAILED = 3;
     */
    FAILED = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class Dataset$Type extends MessageType<Dataset> {
    constructor() {
        super("viam.app.dataset.v1.Dataset", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "time_created", kind: "message", T: () => Timestamp },
            { no: 5, name: "type", kind: "enum", T: () => ["viam.app.dataset.v1.DatasetType", DatasetType, "DATASET_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.dataset.v1.Dataset
 */
export const Dataset = new Dataset$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDatasetRequest$Type extends MessageType<CreateDatasetRequest> {
    constructor() {
        super("viam.app.dataset.v1.CreateDatasetRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "type", kind: "enum", opt: true, T: () => ["viam.app.dataset.v1.DatasetType", DatasetType, "DATASET_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.dataset.v1.CreateDatasetRequest
 */
export const CreateDatasetRequest = new CreateDatasetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDatasetResponse$Type extends MessageType<CreateDatasetResponse> {
    constructor() {
        super("viam.app.dataset.v1.CreateDatasetResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.dataset.v1.CreateDatasetResponse
 */
export const CreateDatasetResponse = new CreateDatasetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDatasetRequest$Type extends MessageType<DeleteDatasetRequest> {
    constructor() {
        super("viam.app.dataset.v1.DeleteDatasetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.dataset.v1.DeleteDatasetRequest
 */
export const DeleteDatasetRequest = new DeleteDatasetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDatasetResponse$Type extends MessageType<DeleteDatasetResponse> {
    constructor() {
        super("viam.app.dataset.v1.DeleteDatasetResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.dataset.v1.DeleteDatasetResponse
 */
export const DeleteDatasetResponse = new DeleteDatasetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RenameDatasetRequest$Type extends MessageType<RenameDatasetRequest> {
    constructor() {
        super("viam.app.dataset.v1.RenameDatasetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.dataset.v1.RenameDatasetRequest
 */
export const RenameDatasetRequest = new RenameDatasetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RenameDatasetResponse$Type extends MessageType<RenameDatasetResponse> {
    constructor() {
        super("viam.app.dataset.v1.RenameDatasetResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.dataset.v1.RenameDatasetResponse
 */
export const RenameDatasetResponse = new RenameDatasetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDatasetsByOrganizationIDRequest$Type extends MessageType<ListDatasetsByOrganizationIDRequest> {
    constructor() {
        super("viam.app.dataset.v1.ListDatasetsByOrganizationIDRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "enum", opt: true, T: () => ["viam.app.dataset.v1.DatasetType", DatasetType, "DATASET_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.dataset.v1.ListDatasetsByOrganizationIDRequest
 */
export const ListDatasetsByOrganizationIDRequest = new ListDatasetsByOrganizationIDRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDatasetsByOrganizationIDResponse$Type extends MessageType<ListDatasetsByOrganizationIDResponse> {
    constructor() {
        super("viam.app.dataset.v1.ListDatasetsByOrganizationIDResponse", [
            { no: 1, name: "datasets", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Dataset }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.dataset.v1.ListDatasetsByOrganizationIDResponse
 */
export const ListDatasetsByOrganizationIDResponse = new ListDatasetsByOrganizationIDResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDatasetsByIDsRequest$Type extends MessageType<ListDatasetsByIDsRequest> {
    constructor() {
        super("viam.app.dataset.v1.ListDatasetsByIDsRequest", [
            { no: 1, name: "ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.dataset.v1.ListDatasetsByIDsRequest
 */
export const ListDatasetsByIDsRequest = new ListDatasetsByIDsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDatasetsByIDsResponse$Type extends MessageType<ListDatasetsByIDsResponse> {
    constructor() {
        super("viam.app.dataset.v1.ListDatasetsByIDsResponse", [
            { no: 1, name: "datasets", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Dataset }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.dataset.v1.ListDatasetsByIDsResponse
 */
export const ListDatasetsByIDsResponse = new ListDatasetsByIDsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MergeDatasetsRequest$Type extends MessageType<MergeDatasetsRequest> {
    constructor() {
        super("viam.app.dataset.v1.MergeDatasetsRequest", [
            { no: 1, name: "dataset_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.dataset.v1.MergeDatasetsRequest
 */
export const MergeDatasetsRequest = new MergeDatasetsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MergeDatasetsResponse$Type extends MessageType<MergeDatasetsResponse> {
    constructor() {
        super("viam.app.dataset.v1.MergeDatasetsResponse", [
            { no: 1, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.dataset.v1.MergeDatasetsResponse
 */
export const MergeDatasetsResponse = new MergeDatasetsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartSequenceDatasetExportRequest$Type extends MessageType<StartSequenceDatasetExportRequest> {
    constructor() {
        super("viam.app.dataset.v1.StartSequenceDatasetExportRequest", [
            { no: 1, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.dataset.v1.StartSequenceDatasetExportRequest
 */
export const StartSequenceDatasetExportRequest = new StartSequenceDatasetExportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartSequenceDatasetExportResponse$Type extends MessageType<StartSequenceDatasetExportResponse> {
    constructor() {
        super("viam.app.dataset.v1.StartSequenceDatasetExportResponse", [
            { no: 1, name: "job_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.dataset.v1.StartSequenceDatasetExportResponse
 */
export const StartSequenceDatasetExportResponse = new StartSequenceDatasetExportResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSequenceDatasetExportRequest$Type extends MessageType<GetSequenceDatasetExportRequest> {
    constructor() {
        super("viam.app.dataset.v1.GetSequenceDatasetExportRequest", [
            { no: 1, name: "job_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.dataset.v1.GetSequenceDatasetExportRequest
 */
export const GetSequenceDatasetExportRequest = new GetSequenceDatasetExportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSequenceDatasetExportResponse$Type extends MessageType<GetSequenceDatasetExportResponse> {
    constructor() {
        super("viam.app.dataset.v1.GetSequenceDatasetExportResponse", [
            { no: 1, name: "job_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "status", kind: "enum", T: () => ["viam.app.dataset.v1.SequenceDatasetExportStatus", SequenceDatasetExportStatus, "SEQUENCE_DATASET_EXPORT_STATUS_"] },
            { no: 3, name: "download_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "expires_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "completed_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.dataset.v1.GetSequenceDatasetExportResponse
 */
export const GetSequenceDatasetExportResponse = new GetSequenceDatasetExportResponse$Type();
/**
 * @generated ServiceType for protobuf service viam.app.dataset.v1.DatasetService
 */
export const DatasetService = new ServiceType("viam.app.dataset.v1.DatasetService", [
    { name: "CreateDataset", options: {}, I: CreateDatasetRequest, O: CreateDatasetResponse },
    { name: "DeleteDataset", options: {}, I: DeleteDatasetRequest, O: DeleteDatasetResponse },
    { name: "RenameDataset", options: {}, I: RenameDatasetRequest, O: RenameDatasetResponse },
    { name: "ListDatasetsByOrganizationID", options: {}, I: ListDatasetsByOrganizationIDRequest, O: ListDatasetsByOrganizationIDResponse },
    { name: "ListDatasetsByIDs", options: {}, I: ListDatasetsByIDsRequest, O: ListDatasetsByIDsResponse },
    { name: "MergeDatasets", options: {}, I: MergeDatasetsRequest, O: MergeDatasetsResponse },
    { name: "StartSequenceDatasetExport", options: {}, I: StartSequenceDatasetExportRequest, O: StartSequenceDatasetExportResponse },
    { name: "GetSequenceDatasetExport", options: {}, I: GetSequenceDatasetExportRequest, O: GetSequenceDatasetExportResponse }
]);
